import { positions } from "@mui/system";

// src/styles/reactSelectStyles.js
export const reactSelectStyles = {
   control: (base, state) => ({
      ...base,
      minHeight: '48px',
      height: '48px',
      borderRadius: '12px',
      borderColor: state.isFocused ? '#2684FF' : '#CED4DA',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
      '&:hover': {
         borderColor: '#2684FF',
      },
   }),
   valueContainer: (base) => ({
      ...base,
      height: '48px',
      padding: '0 12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative'
   }),
   input: (base) => ({
      ...base,
      margin: '0px',
      padding: '0px',
   }),
   indicatorsContainer: (base) => ({
      ...base,
      height: '48px',
   }),
   placeholder: (base) => ({
      ...base,
      margin: '0px',
   }),
   singleValue: (base) => ({
      ...base,
      margin: '0px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // position: 'absolute',
      // top: '50%',
      // left: '5%',
      // transform: 'translateY(-50% + 10px)'

   }),
};


export const reactSelectStylesType1 = {
   control: (base, state) => ({
      ...base,
      minHeight: '48px',
      // height: '48px',
      borderRadius: '12px',
      borderColor: state.isFocused ? '#2684FF' : '#CED4DA',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
      '&:hover': {
         borderColor: '#2684FF',
      },
   }),
   valueContainer: (base) => ({
      ...base,
      // height: '48px',
      padding: '0 12px',
      display: 'flex',
      alignItems: 'center',
      // justifyContent: 'center'
   }),
   input: (base) => ({
      ...base,
      margin: '0px',
      padding: '0px',
   }),
   indicatorsContainer: (base) => ({
      ...base,
      // height: '48px',
   }),
   placeholder: (base) => ({
      ...base,
      margin: '0px',
   }),
   singleValue: (base) => ({
      ...base,
      margin: '0px',
      display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center'
   }),
};

// стилі для react-select-locations
export const selectLocationStyles = {
   control: (base, state) => ({
     ...base,
     minHeight: 48,
     height: 48,
     borderRadius: 12,
     borderColor: state.isDisabled ? '#b1b7c1' : base.borderColor,
     backgroundColor: state.isDisabled ? '#e9ecef' : base.backgroundColor,
   }),
   valueContainer: (base) => ({
     ...base,
     height: 48,
     padding: '0 12px',
   }),
   indicatorsContainer: (base) => ({
     ...base,
     height: 48,
   }),
   option: (base, state) => ({
     ...base,
     fontFamily: 'Geist, sans-serif',
     fontWeight: 400,
     fontSize: 16,
     lineHeight: '150%',
     color: state.isDisabled ? '#b1b7c1' : state.isSelected ? '#ffffff' : '#181d27',
   }),
   input: (base) => ({
     ...base,
     margin: 0,
     padding: 0,
     fontFamily: 'Geist, sans-serif',
     fontWeight: 400,
     fontSize: 16,
     lineHeight: '150%',
     color: '#181d27',
   }),
   singleValue: (base) => ({
     ...base,
     fontFamily: 'Geist, sans-serif',
     fontWeight: 400,
     fontSize: 16,
     lineHeight: '150%',
     color: '#181d27',
   }),
   placeholder: (base) => ({
     ...base,
     fontFamily: 'Geist, sans-serif',
     fontWeight: 400,
     fontSize: 16,
     lineHeight: '150%',
   }),
};
